import { createRouter, createWebHistory } from "vue-router";
import authService from "@/services/authService";

import Body from "../components/body";

/* Auth */
import login from "../auth/login";
import Register from '../auth/register';
import Logout from '../auth/logout';

import Bienvenida from "../pages/bienvenida/bienvenida.vue";
import Blog from "../pages/blog/indice.vue";
import DetallePost from "../pages/blog/detallePost.vue";
import sobreNosotros from "@/pages/nosotros/sobreNosotros.vue";
/* Empresa */
import Perfil from '../pages/empresa/perfil.vue';
import Oportunidades from '../pages/empresa/oportunidades.vue';
/* Biblioteca */
import Documentos from '../pages/biblioteca/documentos.vue';
import DocumentoDetalle from '../pages/biblioteca/documentoDetalle.vue';
/* Directorios */
import Servicios from '../pages/directorios/servicios.vue';
import DetalleServicio from '../pages/directorios/detalleServicio.vue';
/* Instrumentos */
import Instrumentos from '../pages/instrumentos/instrumentos.vue';
import DetalleInstrumento from '../pages/instrumentos/detalleInstrumento.vue';
import NuevoInstrumento from '../pages/instrumentos/nuevoInstrumento.vue';
/* Radiografías */
import meta1 from '../pages/radiografias/meta1.vue';
import meta2 from '../pages/radiografias/meta2.vue';
import meta3 from '../pages/radiografias/meta3.vue';
import meta4a from '../pages/radiografias/meta4a.vue';
import meta4b from '../pages/radiografias/meta4b.vue';
import meta5 from '../pages/radiografias/meta5.vue';
import meta6 from '../pages/radiografias/meta6.vue';
/* Región Portal México Verde */
import bajioVerde from '../pages/bajioVerde/intro.vue';
import fichaEstatal from '../pages/bajioVerde/fichaEstatal.vue';
/* Hoja de ruta */
import hojaRuta from '../pages/hojaRuta/intro.vue';
/* Evaluaciones */
import EvaluacionesIntro from '../pages/evaluaciones/intro.vue';
import EvaluacionesConfiguracion from '../pages/evaluaciones/configuracion.vue';
import NuevoPrograma from '../pages/evaluaciones/nuevoPrograma.vue';
import NuevaMetrica from '../pages/evaluaciones/nuevaMetrica.vue';
import EvaluacionesRegistro from '../pages/evaluaciones/registro.vue';
import EvaluacionesResultados from '../pages/evaluaciones/resultados.vue';
/* Generales */
import MiCuenta from '../pages/generales/micuenta.vue';
/* Diagnóstico */
import Quiz from '../pages/diagnostico/quiz.vue';
import DiagnosticoResultado from '../pages/diagnostico/resultado.vue';
import DiagnosticoQuizPublico from '../pages/diagnostico/quizPublico.vue';
import DiagnosticoResultadoPublico from '../pages/diagnostico/resultadoPublico.vue';
/* Landing */
import Landing from '../pages/landing/landing.vue';
import BlogPostPublico from '../pages/landing/blogPostPublico.vue';


const routes = [
  {
    path: "/",
    name: "landing",
    component: Landing,
    meta: {
      title: "Portal México Verde",
      public: true,
    },
  },
  {
    path: "/blog/:id",
    name: "blogPostPublico",
    component: BlogPostPublico,
    meta: { title: "Portal México Verde | Blog", public: true },
  },
  {
    path: "/diagnostico",
    name: "diagnosticoPublicoQuiz",
    component: DiagnosticoQuizPublico,
    meta: { title: "Portal México Verde | Diagnóstico de Reverdecimiento", public: true },
  },
  {
    path: "/diagnostico/resultado",
    name: "diagnosticoPublicoResultado",
    component: DiagnosticoResultadoPublico,
    meta: { title: "Portal México Verde | Resultado del Diagnóstico", public: true },
  },
  {
    path: "/app",
    component: Body,
    redirect: "/app/bienvenida",
    children: [
      {
        path: "bienvenida",
        name: "bienvenida",
        component: Bienvenida,
        meta: {
          title: "Portal México Verde | Bienvenida",
        },
      },      
      {
        path: "blog",
        name: "blog",
        component: Blog,
        meta: {
          title: "Portal México Verde | Blog",
        },
      },
      {
        path: "blog/post/:id",
        name: "detallePost",
        component: DetallePost,
        meta: {
          title: "Portal México Verde | Blog",
        },
      },
      {
        path: "nosotros",
        name: "sobreNosotros",
        component: sobreNosotros,       
        meta: {
          title: "Portal México Verde | Sobre Nosotros",
        }, 
      },
      {
        path: "bajioVerde",
        name: "bajioVerde",
        component: bajioVerde,
        meta: {
          title: "Portal México Verde | Región Bajío",
        },
      },     
      {
        path: "bajioVerde/fichaEstatal/:idestado",
        name: "fichaEstatal",
        component: fichaEstatal,
        meta: {
          title: "Portal México Verde | Ficha Estatal",
        },
      },
       {
        path: "hojaRuta",
        name: "Hoja de ruta",
        component: hojaRuta,
        meta: {
          title: "Portal México Verde | Hoja de Ruta",
        },
      },      
      {
        path: "radiografias/meta1",
        name: "meta1",
        component: meta1,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "radiografias/meta2",
        name: "meta2",
        component: meta2,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "radiografias/meta3",
        name: "meta3",
        component: meta3,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "radiografias/meta4a",
        name: "meta4a",
        component: meta4a,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "radiografias/meta4b",
        name: "meta4b",
        component: meta4b,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "diagnostico/quiz",
        name: "quiz",
        component: Quiz,
        meta: {
          title: "Giz - AMSDE | Diagnóstico de Reverdecimiento",
        },
      },
      {
        path: "diagnostico/resultado/:resultado?",
        name: "diagnosticoResultado",
        component: DiagnosticoResultado,
        meta: {
          title: "Giz - AMSDE | Resultado del Diagnóstico",
        },
      },
      {
        path: "radiografias/meta5",
        name: "meta5",
        component: meta5,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "radiografias/meta6",
        name: "meta6",
        component: meta6,
        meta: {
          title: "Giz - AMSDE | Radiografía Verde por Meta",
        },
      },
      {
        path: "directorios/servicios",
        name: "serviciosEmpresariales",
        component: Servicios,
        meta: {
          title: "Giz - AMSDE | Servicios Empresariales",
        },
      },
      {
        path: "directorios/servicios/:id",
        name: "detalleServicio",
        component: DetalleServicio,
        meta: {
          title: "Portal México Verde | Perfil de empresa",
        },
      },
      {
        path: "instrumentos/instrumentos",
        name: "instrumentos",
        component: Instrumentos,
        meta: {
          title: "Portal México Verde | Instrumentos",
        },
      },
      {
        path: "instrumentos/instrumentos/:id",
        name: "detalleInstrumento",
        component: DetalleInstrumento,
        meta: {
          title: "Portal México Verde | Detalle de instrumento",
        },
      },
      {
        path: "instrumentos/nuevo",
        name: "nuevoInstrumento",
        component: NuevoInstrumento,
        meta: {
          title: "Portal México Verde | Registrar instrumento",
        },
      },
      {
        path: "biblioteca/documentos",
        name: "documentosBiblioteca",
        component: Documentos,
        meta: {
          title: "Giz - AMSDE | Documentos Biblioteca",
        },
      },
      {
        path: "biblioteca/documentos/:id",
        name: "documentoDetalle",
        component: DocumentoDetalle,
        meta: {
          title: "Giz - AMSDE | Detalle de Documento",
        },
      },
      {
        path: "empresa/perfilEmpresa",
        name: "perfilEmpresa",
        component: Perfil,
        meta: {
          title: "Giz - AMSDE | Perfil Empresarial",
        },
      },
      {
        path: "empresa/oportunidades",
        name: "oportunidadesEmpresa",
        component: Oportunidades,
        meta: {
          title: "Giz - AMSDE | Oportunidades para incorporarte a la cadena de valor verde",
        },
      },
      {
        path: "generales/micuenta",
        name: "miCuenta",
        component: MiCuenta,
        meta: {
          title: "Giz - AMSDE | Mi Cuenta",
        },
      },
      {
        path: "evaluaciones",
        name: "evaluacionesIntro",
        component: EvaluacionesIntro,
        meta: {
          title: "Portal México Verde | Evaluaciones",
        },
      },
      {
        path: "evaluaciones/configuracion",
        name: "evaluacionesConfiguracion",
        component: EvaluacionesConfiguracion,
        meta: {
          title: "Portal México Verde | Evaluaciones · Configuración",
        },
      },
      {
        path: "evaluaciones/configuracion/nuevo-programa",
        name: "nuevoPrograma",
        component: NuevoPrograma,
        meta: {
          title: "Portal México Verde | Nuevo Programa",
        },
      },
      {
        path: "evaluaciones/configuracion/nueva-metrica/:programaId",
        name: "nuevaMetrica",
        component: NuevaMetrica,
        meta: {
          title: "Portal México Verde | Nueva Métrica",
        },
      },
      {
        path: "evaluaciones/registro",
        name: "evaluacionesRegistro",
        component: EvaluacionesRegistro,
        meta: {
          title: "Portal México Verde | Evaluaciones · Registro",
        },
      },
      {
        path: "evaluaciones/resultados",
        name: "evaluacionesResultados",
        component: EvaluacionesResultados,
        meta: {
          title: "Portal México Verde | Evaluaciones · Resultados",
        },
      }
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/auth",
    children: [
      {
        path: "login",
        name: "Login 1",
        component: login,
        meta: {
          title: " Giz -AMSDE | Login",
        },
      },
      {
        path: 'register',
        name: 'register 1',
        component: Register,
        meta: {
          title: ' Giz -AMSDE | Register',
        }
      },
      {
        path: 'logout',
        name: 'logout',
        component: Logout,
        meta: {
          title: 'Giz - AMSDE | Cerrar Sesión',
        }
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;
  const publicPaths = ["/", "/auth/login", "/auth/register", "/auth/logout"];
  if (publicPaths.includes(to.path) || to.meta.public) {
    return next();
  }
  if (!authService.isAuthenticated()) {
    return next("/auth/login");
  }

  // Verificar acceso por perfil
  const group = authService.getUserGroup();
  if (group && !isRouteAllowed(to.path, group)) {
    return next("/app/bienvenida");
  }

  next();
});

// Rutas bloqueadas por perfil (el resto es accesible)
const BLOCKED_ROUTES = {
  Gobierno: ['/app/diagnostico', '/app/empresa'],
  Inversionista: ['/app/diagnostico', '/app/hojaRuta'],
};

function isRouteAllowed(path, group) {
  const blocked = BLOCKED_ROUTES[group];
  if (!blocked) return true; // AMSDE, Tractora, MiPyMEs: acceso total
  return !blocked.some(prefix => path.startsWith(prefix));
}

export default router;
